const Configuration = {
  empty: 'empty',  // no configuration
  S: 'S',       // S
  SP: 'SP',     // S with P
  SPP: 'SPP',   // S with 2Ps
  SPPP: 'SPPP', // S with 3Ps,
  P: 'P',       // P
  PP: 'PP',     // 2Ps
  PPP: 'PPP',   // 3Ps 
  sp: 'sp',     // sp
  sp2: 'sp2',   // sp2
  sp3: 'sp3',   // sp3
  spP: 'spP',   // sp with a P
  spPP: 'spPP', // sp with 2 Ps
  sp2P: 'sp2P', // sp2 with a P
  sp3d: 'sp3d', // sp3d
  sp3d2: 'sp3d2', // sp3d2
  D: 'D',       // D
  DD: 'DD',     // 2Ds
  SD: 'SD',     // S with D
  SDD: 'SDD',   // S with 2Ds
  SPD: 'SPD',   // S with P and D
  SPDD: 'SPDD', // S with P and 2Ds
  SPPD: 'SPPD',
  SPPDD: 'SPPDD',
  SPPPD: 'SPPPD',
  SPPPDD: 'SPPPDD',
  PD: 'PD',
  PDD: 'PDD',
  PPD: 'PPD',
  PPDD: 'PPDD',
  PPPD: 'PPPD',
  PPPDD: 'PPPDD'
};

export default Configuration;